import { NgModule } from '@angular/core';

import { KeysPipe } from './keys.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { FilterPipe } from './filter.pipe';
import { CamelCaseToDashPipe } from './camelCaseToDash.pipe';
import {OrdersDataFilterPipe} from './orders-data-filter.pipe';
import {TravelsDataFilterPipe} from './travels-data-filter.pipe';

@NgModule({
    declarations: [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        OrdersDataFilterPipe,
        TravelsDataFilterPipe
    ],
    imports     : [],
    exports     : [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        OrdersDataFilterPipe,
        TravelsDataFilterPipe
    ]
})

export class FusePipesModule
{

}



// WEBPACK FOOTER //
// ./src/app/core/pipes/pipes.module.ts